import React from 'react'
import PropTypes from 'prop-types'

// Every step's title block, fixed at h2 under the wizard root's visually hidden h1.

const PageHeader = ({ title, subtitle, children }) => (
  <div className="gl-page-hd">
    <h2 className="gl-page-hd-title">{title}</h2>
    {subtitle && <p className="gl-page-hd-sub">{subtitle}</p>}
    {children}
  </div>
)

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node,
}

export default PageHeader
